import Vue from 'vue';
import VueI18n, {LocaleMessages} from 'vue-i18n';

Vue.use(VueI18n);

export const FALLBACK_LANGUAGE = 'zh-CN';

/**
 * 获取当前语言
 * @returns 语言
 */
function getCurrentLocale() {
    let locale = '';
    // 从浏览器地址栏中解析locale数据
    const languageFromUrl = window.top?.location.search
        .slice(1)
        .split('&')
        .find((item: string) => item.startsWith('locale=')) || '';
    if (languageFromUrl) {
        locale = languageFromUrl.split('=')[1];
    }
    if (locale) {
        return locale;
    }
    const languageFromStorage = localStorage.getItem('LANGUAGE');
    if (languageFromStorage) {
        locale = languageFromStorage;
    }
    return locale || FALLBACK_LANGUAGE;
}

function loadLocaleMessages(): LocaleMessages {
    // OPT: require.context 为 webpack 的功能
    // vue-jest 无法使用 webpack 的功能，所以会导致单测运行时无法加载这部分文件
    // 从而使单测运行时 控制台有很多 i18n 相关的警告
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\/[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: LocaleMessages = {};
    locales.keys().forEach(key => {
        const matched = /.\/([A-Za-z0-9-_]+)\//i.exec(key);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = {
                ...(messages[locale] || {}),
                ...locales(key),
            };
        }
    });
    return messages;
}
const locales = loadLocaleMessages();

const i18n = new VueI18n({
    locale: getCurrentLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: {
        'en': locales.en,
        'en-us': locales.en,
        'zh': locales['zh-CN'],
        'zh-cn': locales['zh-CN'],
    },
    // 关闭vue-i18n在控制台中的警告
    silentTranslationWarn: true,
});

export default i18n;

export const locale = {
    get isZhLang() {
        return i18n.locale?.includes('zh');
    },
    get isEnglish() {
        return i18n.locale?.includes('en') || !i18n.locale?.includes('zh');
    },
};
